import React from "react";
import { BreadCrumb } from "./BreadCrumb";
import { Flex, Table } from "@radix-ui/themes";

const eth = require("../data/data-dict/nftassets-eth.json"),
    polygon = require("../data/data-dict/nftassets-polygon.json"),
    bsc = require("../data/data-dict/nftassets-bsc.json"),
    arb = require("../data/data-dict/nftassets-arbitrum.json"),
    opt = require("../data/data-dict/nftassets-optimism.json"),
    zora = require("../data/data-dict/nftassets-zora.json"),
    base = require("../data/data-dict/nftassets-base.json");


const nftCollections_eth = require("../data/data-dict/nftcollections-eth.json");
const nftCollections_polygon = require("../data/data-dict/nftcollections-polygon.json");
const nftCollections_bsc = require("../data/data-dict/nftcollections-bsc.json");

const activeToken_eth = require("../data/data-dict/active-tokens-eth.json");
const activeToken_bsc = require("../data/data-dict/active-tokens-bsc.json");
const activeToken_polygon = require("../data/data-dict/active-tokens-polygon.json");

const dexTrades_eth = require("../data/data-dict/dextrades-eth.json");
const dexTrades_bsc = require("../data/data-dict/dextrades-bsc.json");
const dexTrades_polygon = require("../data/data-dict/dextrades-polygon.json");

const dexPairs_eth = require("../data/data-dict/dexpairs-eth.json");
const dexPairs_bsc = require("../data/data-dict/dexpairs-bsc.json");
const dexPairs_polygon = require("../data/data-dict/dexpairs-polygon.json");

const nftTrades_eth = require("../data/data-dict/nfttrade-eth.json");
const nftTrades_polygon = require("../data/data-dict/nfttrade-polygon.json");
const nftTrades_bsc = require("../data/data-dict/nfttrade-bsc.json");

export default function Coverage() {
    const count_assets = (x) => {
        let s = 0;
        x.data.items.forEach((y) => {
            s += y.cached_asset_count;
        });
        return s;
    };
    const count_metadata = (x) => {
        let s = 0;
        x.data.items.forEach((y) => {
            s += y.cached_metadata_count;
        });
        return s;
    };
    const count_collections = (x) => {
        return x.data.items.length;
    };

    const eth_col = count_collections(eth),
        polygon_col = count_collections(polygon),
        bsc_col = count_collections(bsc),
        arb_col = count_collections(arb),
        opt_col = count_collections(opt),
        base_col = count_collections(base),
        zora_col = count_collections(zora),
        eth_meta = count_metadata(eth),
        polygon_meta = count_metadata(polygon),
        bsc_meta = count_metadata(bsc),
        arb_meta = count_metadata(arb),
        base_meta = count_metadata(base),
        zora_meta = count_metadata(zora),
        opt_meta = count_metadata(opt),
        eth_assets = count_assets(eth),
        polygon_assets = count_assets(polygon),
        bsc_assets = count_assets(bsc),
        arb_assets = count_assets(arb),
        base_assets = count_assets(base),
        zora_assets = count_assets(zora),
        opt_assets = count_assets(opt);

    const nftCollections_col_eth = Number(nftCollections_eth.data.items[0]["uniq(collection_address)"]),
        nftCollections_col_polygon = Number(nftCollections_polygon.data.items[0]["uniq(collection_address)"]),
        nftCollections_col_bsc = Number(nftCollections_bsc.data.items[0]["uniq(collection_address)"]);

    const nftTrades_col_eth = Number(nftTrades_eth.data.items[0]["count()"]),
        nftTrades_col_polygon = Number(nftTrades_polygon.data.items[0]["count()"]),
        nftTrades_col_bsc = Number(nftTrades_bsc.data.items[0]["count()"]);

    const activeToken_col_eth = Number(activeToken_eth.data.items[0]["active_tokens"]),
        activeToken_col_polygon = Number(activeToken_polygon.data.items[0]["active_tokens"]),
        activeToken_col_bsc = Number(activeToken_bsc.data.items[0]["active_tokens"]);

    const dexTrades_col_eth = Number(dexTrades_eth.data.items[0]["count()"]),
        dexTrades_col_polygon = Number(dexTrades_polygon.data.items[0]["count()"]),
        dexTrades_col_bsc = Number(dexTrades_bsc.data.items[0]["count()"]);

    const dexPairs_col_eth = Number(dexPairs_eth.data.items[0]["count()"]),
        dexPairs_col_polygon = Number(dexPairs_polygon.data.items[0]["count()"]),
        dexPairs_col_bsc = Number(dexPairs_bsc.data.items[0]["count()"]);

    return <div>
        <BreadCrumb title={"Data Coverage"}/>
        <Flex direction="column" gap="3" mt="6">
            <h1>On-Chain Coverage</h1>
            <p>
            With over 100 chains currently supported, Covalent's breadth of chain coverage is unparalleled. Whether it's an event, a token or a transaction, Covalent captures it in real-time.
            </p>
            <div className="table-container">
                <Table.Root variant="surface">
                    <Table.Header>
                        <Table.Row>
                            <Table.RowHeaderCell />
                            <Table.RowHeaderCell align="right">Ethereum</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Polygon</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">BNB Smart Chain</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Total</Table.RowHeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell><div >Active Tokens</div>
                            </Table.Cell>
                            <Table.Cell align="right">{activeToken_col_eth.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{activeToken_col_polygon.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{activeToken_col_bsc.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(activeToken_col_eth + activeToken_col_polygon + activeToken_col_bsc).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table.Root>
            </div>
            <h2>DeFi Coverage</h2>
            <p>
            Covalent's DeFi data coverage is best in class, providing data availability for every on-chain protocol all the way back to its inception. This ensures that our users can access the most comprehensive and accurate DeFi data.
            </p>
            <div className="table-container">
                <Table.Root variant="surface">
                    <Table.Header>
                        <Table.Row>
                            <Table.RowHeaderCell />
                            <Table.RowHeaderCell align="right">Ethereum</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Polygon</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">BNB Smart Chain</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Total</Table.RowHeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <tbody>
                        <Table.Row>
                            <Table.Cell><div >Dex Trades</div>
                            </Table.Cell>
                            <Table.Cell align="right">{dexTrades_col_eth.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{dexTrades_col_polygon.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{dexTrades_col_bsc.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(dexTrades_col_eth + dexTrades_col_polygon + dexTrades_col_bsc).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><div >Dex Pairs</div>
                            </Table.Cell>
                            <Table.Cell align="right">{dexPairs_col_eth.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{dexPairs_col_polygon.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{dexPairs_col_bsc.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(dexPairs_col_eth + dexPairs_col_polygon + dexPairs_col_bsc).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                    </tbody>
                </Table.Root>
            </div>
            <h2>NFT Coverage</h2>
            <p>NFT Token metadata and assets are stored off-chain, usually behind heavily rate-limited APIs, non-standard formats, and gigantic file sizes  - without thumbnails, and unoptimized images. Covalent has downloaded the metadata, assets and other related information and cached them on our side for the best developer experience.</p>
            <div className="table-container">
                <Table.Root variant="surface">
                    <Table.Header>
                        <Table.Row>
                            <Table.RowHeaderCell />
                            <Table.RowHeaderCell align="right">Ethereum</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Polygon</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">BNB Smart Chain</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Arbitrum</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Optimism</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Base</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Zora</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Total</Table.RowHeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <tbody>
                        <Table.Row>
                            <Table.Cell>Crawled NFT Token Metadata External token metadata downloaded, normalized and cached by Covalent.</Table.Cell>
                            <Table.Cell align="right">{eth_meta.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{polygon_meta.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{bsc_meta.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{arb_meta.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{opt_meta.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{base_meta.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{zora_meta.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(eth_meta + polygon_meta + bsc_meta + arb_meta + opt_meta + base_meta + zora_meta).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><div >Crawled NFT Token Assets</div>
                                External token assets downloaded, thumbnailed and cached by Covalent.</Table.Cell>
                            <Table.Cell align="right">{eth_assets.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{polygon_assets.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{bsc_assets.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{arb_assets.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{opt_assets.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{base_assets.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{zora_assets.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(eth_assets + polygon_assets + bsc_assets + arb_assets + opt_assets + base_assets + zora_assets).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><div >Crawled NFT Collections</div>
                            </Table.Cell>
                            <Table.Cell align="right">{eth_col.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{polygon_col.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{bsc_col.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{arb_col.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{opt_col.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{base_col.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{zora_col.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(eth_col + polygon_col + bsc_col + arb_col + opt_col + base_col + zora_col).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                    </tbody>
                </Table.Root>
            </div>

            <h2>On-chain</h2>
            
            <div className="table-container">
                <Table.Root variant="surface">
                    <Table.Header>
                        <Table.Row>
                            <Table.RowHeaderCell />
                            <Table.RowHeaderCell align="right">Ethereum</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Polygon</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">BNB Smart Chain</Table.RowHeaderCell>
                            <Table.RowHeaderCell align="right">Total</Table.RowHeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <tbody>
                        <Table.Row>
                            <Table.Cell><div >NFT Collections</div>
                            </Table.Cell>
                            <Table.Cell align="right">{nftCollections_col_eth.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{nftCollections_col_polygon.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{nftCollections_col_bsc.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(nftCollections_col_eth + nftCollections_col_polygon + nftCollections_col_bsc).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><div >NFT Trades</div>
                            </Table.Cell>
                            <Table.Cell align="right">{nftTrades_col_eth.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{nftTrades_col_polygon.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{nftTrades_col_bsc.toLocaleString("en-US")}</Table.Cell>
                            <Table.Cell align="right">{(nftTrades_col_eth + nftTrades_col_polygon + nftTrades_col_bsc).toLocaleString("en-US")}</Table.Cell>
                        </Table.Row>
                    </tbody>
                </Table.Root>
            </div>
        </Flex>
        <style jsx>
            {`
                .table-container {
                    margin-bottom: var(--default-vertical-spacing);
                }
            `}
        </style>
    </div>;
}
